import React, { Component } from 'react';
import denied from '../asset/img/denied.png';
import checkmark from '../asset/img/checkmark.png';
import questionmark from '../asset/img/questionmark.png';
import Validation from '../container/Validation.js'

export default class ApproveContent extends Component{
	constructor(props){
		super(props);
		this.onclick = this.onclick.bind(this);
		//this.editThankyou = this.editThankyou.bind(this);
	}

	onclick(e){ //method for handling the click of a button
		let val = e.currentTarget.value;
		this.props.click(val,this.props.identity);
	}

	render(){
		const approve = { //styling for approve button
			backgroundImage: 'url('+checkmark+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '26px 24px',
			minWidth: '26px',
			minHeight:'24px'
		};
		const deny = { //styling for deny button
			backgroundImage: 'url('+denied+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '26px 24px',
			minWidth: '26px',
			minHeight:'24px'
		};
		const review = { //styling for review button
			backgroundImage: 'url('+questionmark+')',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center',
			backgroundColor: 'white',
			backgroundSize: '26px 24px',
			minWidth: '26px',
			minHeight:'24px'
		};
		const cols = this.props.columns;
		const tdata = Object.keys(cols).map((col,i) => { //map object passed down through columns prop and return column data for each key
			let theid = this.props.identity+"_"+col+"_"+this.props.child;
			let td_id = theid+"_td";
			let isEditable = col === "Reason"?true:false;
			return <td key={i} id={td_id} className="ba b--gray" style={{maxWidth:'300px',wordWrap:'break-word'}}><span id={theid} onBlur={this.props.edit} contentEditable={isEditable}>{cols[col]}</span></td>;
		});
		let buttons;
		let extra;

		if (this.props.user === "admin" && this.props.kind === "thankyou"){ //review button for pending thank yous
			extra =  <button className="br2 mt0" value="review" onClick={this.onclick} style={review}></button>;
		}
		buttons = <td className="tc bg-white ba b--gray" style={{minWidth:'85px'}}>
								<button className="br2 mt1" value="approved" onClick={this.onclick} style={approve}></button>
								<button className="br2 mt1" value="denied" onClick={this.onclick} style={deny}></button>{extra}
							</td>;

		return(
				<tr className="stripe-blue">
					{tdata}
					{buttons}
				</tr>
		);
	}
}


// WEBPACK FOOTER //
// ./src/component/ApproveContent.js